module.exports = __webpack_public_path__ + "static/img/completed.cfbc09d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/user-onboarding/completed.png
// module id = LgSk
// module chunks = 45